import { useState } from 'react';
import { ConfirmationModal, IconButton, useOverlayContext } from 'seagull';
import { TrashLine } from 'seagull/icons';
import { useStoreActions } from "../../../../../contexts";
import { Intent } from "../../../../../infra/access-control";
import { ErrorResponse, ServerError } from "../../../../../infra/ErrorResponse";
import { jsx as _jsx } from "react/jsx-runtime";
export function CreditDeleteButton(props) {
  const {
    chargeId,
    agreementId,
    disabled,
    tooltipTitle,
    'data-testid': testid,
    onRefresh
  } = props;
  const [loading, setLoading] = useState(false);
  const overlayContext = useOverlayContext();
  const {
    api,
    logBI
  } = useStoreActions();
  async function onDelete() {
    const confirmed = await overlayContext.showModal({
      closeOnClickOutside: true,
      shouldBlurBackground: true,
      closeOnEscapeKey: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/_jsx(ConfirmationModal, {
          skin: "danger",
          title: "Are you sure?",
          content: "You are about to remove credit from your client's account. Your client will be notified on this change.",
          primaryButtonLabel: "Remove credit",
          secondaryButtonLabel: "Cancel",
          onPrimaryButtonClick: () => dismissModal(true),
          onSecondaryButtonClick: () => dismissModal(false)
        });
      }
    });
    if (!confirmed) return;
    setLoading(true);
    logBI(10567);
    try {
      await api.charge.deleteCredit(agreementId, chargeId);
      await onRefresh({
        silent: true
      });
      overlayContext.showSuccessToast('Credit removed', "".concat(testid, "-success"));
    } catch (err) {
      setLoading(false);
      const e = new ErrorResponse(err);
      const errorText = e.hasServerError(ServerError.AdHocChargeNotFound) ? 'Failed to remove credit. It was already removed' : 'Failed to remove credit, please try again or contact support@sayanchor.com for assistance';
      overlayContext.showErrorToast(errorText, "".concat(testid, "-failure"));
    }
  }
  return /*#__PURE__*/_jsx(IconButton, {
    onClick: onDelete,
    disabled: disabled || loading,
    skin: "primary",
    "data-testid": testid,
    intent: Intent.RemoveCredit,
    tooltip: {
      placement: 'top',
      title: /*#__PURE__*/_jsx("div", {
        "data-testid": testid && "".concat(testid, "-tooltip"),
        children: tooltipTitle || 'Remove credit'
      })
    },
    children: /*#__PURE__*/_jsx(TrashLine, {})
  });
}